import { createFileRoute } from '@tanstack/react-router';

import { EventsPage } from '../modules/events/ui/pages/EventsPage';

export const Route = createFileRoute('/_authenticated/dashboard/events/')({
  component: EventsPage,
  staticData: {
    breadcrumb: ['Manage', 'Events'],
  },
});
